// extracted by mini-css-extract-plugin
export default {"container":"AppSidebar_container_ooq7Z","body":"AppSidebar_body_i3sjy"};